import * as Prism from 'prismjs';
import { useEffect, useMemo, useRef } from 'react';
import './prism-languages';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';

const styledProps = {
  display: 'flex',
  width: '100%',
  height: '38Rem',
  flexWrap: 'wrap',
  overflowY: 'scroll',
  justifyContent: 'flex-start',
  whiteSpace: 'pre-wrap',
  alignItems: 'flex-start',
  padding: '0.5em',
  background: '#272822',
  color: '#ddd',
  scrollbarWidth: 'thin',
  scrollbarColor: '#90A4AE #CFD8DC',
};

/**
 * RequestLogger
 *
 * Componente para mostrar logs o código con resaltado de sintaxis usando PrismJS.
 *
 * @component
 * @param {boolean} [async] - Si el resaltado debe ser asíncrono
 * @param {string|React.ReactNode} [children] - Código o texto a mostrar
 * @param {string} [className] - Clases CSS adicionales para el contenedor
 * @param {React.ElementType} [component='code'] - Componente a usar como wrapper
 * @returns {JSX.Element}
 */
export const RequestLogger = styled(
  ({ async, children = '', className, component: Wrapper = 'code' }) => {
    const domNode = useRef(null);

    useEffect(() => {
      if (domNode.current) {
        Prism.highlightAll(domNode.current, async);
      }
    }, [children, async]);

    return useMemo(() => {
      return (
        <Wrapper ref={domNode} className={clsx('border', className)}>
          {children}
        </Wrapper>
      );
    }, [children, className]);
  }
)(({ theme }) => styledProps);
